import { render, staticRenderFns } from "./PlainTextReader.vue?vue&type=template&id=36a3fd64&"
import script from "./PlainTextReader.vue?vue&type=script&lang=js&"
export * from "./PlainTextReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports